import React from "react";
import { useSelector } from "react-redux";

// Small brand-name chip shown in front of a post's title. The All Posts
// views mix posts from every brand, so this makes each post's owning
// brand obvious at a glance. The name is resolved from the loaded
// brands list by brand_id (posts already carry brand_id); renders
// nothing if the brand can't be resolved.
const PostBrandLabel = ({ brandId, brandName }) => {
  const brands = useSelector((s) => s.user.brands);
  const name =
    brandName ||
    (brands || []).find((b) => String(b && b._id) === String(brandId))?.name;
  if (!name) return null;
  return (
    <span
      className="post-brand-label"
      title={name}
      style={{
        display: "inline-block",
        maxWidth: 150,
        overflow: "hidden",
        textOverflow: "ellipsis",
        whiteSpace: "nowrap",
        verticalAlign: "bottom",
        fontSize: "0.72em",
        fontWeight: 700,
        color: "#3a5765",
        background: "#eef2f4",
        border: "1px solid #d8dee4",
        borderRadius: 4,
        padding: "1px 6px",
        marginRight: 6,
      }}
    >
      {name}
    </span>
  );
};

export default PostBrandLabel;
